import * as React from "react";
import { observer } from "mobx-react";
import { UitkCard, UitkCardContentSection } from "@egds/react-core/cards";
import { UitkHeading, UitkText } from "@egds/react-core/text";
import { UitkLayoutGrid, UitkLayoutGridColumnRow } from "@egds/react-core/layout-grid";
import { UitkSpacing } from "@egds/react-core/spacing";

import Link from "./components/Link";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { CrossLOBLinksProps, IconMap } from "./typings";
import { withStores } from "src/stores";

import { CrossLobLinksFlexModuleResult } from "typings/microserviceModels/cross-lob-links-flex-module";
import { LazyLoad } from "src/components/utility/LazyLoad/LazyLoad";

export const CrossLOBLinks = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: CrossLOBLinksProps) => {
    const { templateComponent, flexModuleModelStore, context } = props;
    const { id } = templateComponent.metadata;
    const model = flexModuleModelStore.getModel(id) as CrossLobLinksFlexModuleResult | null;

    /* istanbul ignore next */
    if (!model) {
      return null;
    }

    const { links, title, description, displayColumns } = model;

    if (!links?.length) {
      return null;
    }

    const DEFAULT_MOBILE_DISPLAY_COLUMNS = 1;
    const columns = {
      small: DEFAULT_MOBILE_DISPLAY_COLUMNS as UitkLayoutGridColumnRow,
      large: Number(displayColumns) as UitkLayoutGridColumnRow,
    };

    const keyHelper = new ItemKeyHelper("CrossLOBLinks");

    return (
      <>
        <LazyLoad context={context}>
          <UitkSpacing padding={{ block: "six" }}>
            <div
              id={id}
              className="CrossLOBLinks"
              data-fm={templateComponent.config.fmId}
              data-fm-title-id={templateComponent.config.fmTitleId}
            >
              <UitkCard>
                <UitkCardContentSection>
                  {title && (
                    <UitkHeading tag="h2" size={4}>
                      {title}
                    </UitkHeading>
                  )}

                  {description && <UitkText spacing="two">{description}</UitkText>}

                  <UitkSpacing margin={{ blockstart: "two" }}>
                    <UitkLayoutGrid columns={columns} space="one">
                      {links.map((link) => (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <Link key={keyHelper.next()} link={link} />
                      ))}
                    </UitkLayoutGrid>
                  </UitkSpacing>
                </UitkCardContentSection>
              </UitkCard>
            </div>
          </UitkSpacing>
        </LazyLoad>
      </>
    );
  })
);

// This map contains the mapping for the icon types from the backend response to corresponding UitkIcon
export const iconMap: IconMap = {
  flights: "lob_flights",
  house: "lob_vacation_rentals",
  hotels: "lob_hotels",
  cars: "lob_cars",
  packages: "lob_packages",
  activities: "lob_activities",
};

export default CrossLOBLinks;
